"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomModulePlanBase = void 0;
const ModulePlanStatus_1 = require("./ModulePlanStatus");
const constants_1 = require("../../constants");
/* eslint-disable require-jsdoc */
class CustomModulePlanBase {
    constructor(authorId, title, description, subject, imageString = undefined) {
        this.planStatus = ModulePlanStatus_1.ModulePlanStatus.Draft;
        this.selectedConceptMaterialIds = []; // this property is the order
        this.authorId = authorId;
        this.title = title;
        this.description = description;
        this.subject = subject;
        this.imageString = imageString;
    }
    static collectionPath() {
        return constants_1.constants.COLLECTION_PATH_CUSTOM_MODULE_PLAN;
    }
}
exports.CustomModulePlanBase = CustomModulePlanBase;
